import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import TasteTestApp from "@/components/TasteTestApp";

function App() {
  return (
    <div className="App">
      <TasteTestApp />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
